import Pagination from './src/pagination.mjs';
export { paginationEmits, paginationProps } from './src/pagination.mjs';
export { elPaginationKey } from './src/constants.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElPagination = withInstall(Pagination);

export { ElPagination, ElPagination as default };
//# sourceMappingURL=index.mjs.map
